import React from 'react';
import { FiAlertTriangle, FiX, FiRefreshCw } from 'react-icons/fi';

/**
 * Warning Modal สำหรับ broker connection limit
 * แสดงเมื่อ user พยายามเชื่อมต่อ broker ใหม่ขณะที่มี active broker อยู่แล้ว
 */
const BrokerConnectionWarningModal = ({ 
  isOpen, 
  onClose, 
  onDisconnectAndConnect, 
  onCancel,
  currentBroker,
  newBroker,
  isDisconnecting = false 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-900 rounded-lg p-6 max-w-md w-full mx-4 border border-gray-700">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <FiAlertTriangle className="text-yellow-500 text-xl" />
            <h3 className="text-lg font-semibold text-white">
              Broker Already Connected
            </h3>
          </div>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-white transition-colors"
            disabled={isDisconnecting}
          >
            <FiX className="text-xl" />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-gray-300 mb-4">
            You already have an active broker connection:
          </p>
          
          <div className="bg-gray-800 rounded-lg p-3 mb-4">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-white font-medium capitalize">
                {currentBroker}
              </span>
              <span className="text-gray-400 text-sm">(Active)</span>
            </div>
          </div>

          <p className="text-gray-300 mb-4">
            To connect to <span className="text-purple-400 font-medium capitalize">{newBroker}</span>, 
            you need to disconnect your current broker first.
          </p>

          <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-3">
            <p className="text-yellow-400 text-sm">
              <strong>Note:</strong> Disconnecting will stop all automated trading activities 
              and you'll need to reconfigure your trading settings.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex space-x-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors disabled:opacity-50"
            disabled={isDisconnecting}
          >
            Cancel
          </button>
          
          <button
            onClick={onDisconnectAndConnect}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center justify-center space-x-2"
            disabled={isDisconnecting}
          >
            {isDisconnecting ? (
              <>
                <FiRefreshCw className="animate-spin" />
                <span>Disconnecting...</span>
              </>
            ) : (
              <>
                <FiX className="text-sm" />
                <span>Disconnect</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrokerConnectionWarningModal;
